import { ComponentType, type IConfig } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.Box,
  configGroups: [
    {
      title: 'Component Settings',
      items: [
        {
          name: 'visible',
          label: 'Visible',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'True', value: true },
              { label: 'False', value: false },
            ],
            defaultValue: true,
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
